<template>
	<!-- 数据统计 -->
	<div class="wrap">
		<div class="head">
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/12228@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>98</div>
					<div>申请资质总数</div>
				</div>
			</div>
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/20@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>48,566</div>
					<div>申请印制资质数量</div>
				</div>
			</div>
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/10784@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>8,309</div>
					<div>申请军工资质数量</div>
				</div>
			</div>
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/10785@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>46,560</div>
					<div>申请集成资质数量</div>
				</div>
			</div>
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/10786@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>98</div>
					<div>申请单位总数</div>
				</div>
			</div>
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/10787@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>9,198,176</div>
					<div>申请通过率</div>
				</div>
			</div>
		</div>
		<div class="tabs">
			<div class="tabs_item" :class="{'isItem':isActive==0}" @click="checkItem(0)">本月</div>
			<div class="tabs_item" :class="{'isItem':isActive==1}" @click="checkItem(1)">本周</div>
		</div>
		<div class="content">
			<div class="content_left">
				<div class="title">
					企业资料提交情况
				</div>
				<div class="left_echart">
					<div id="leftEcharts" class="full"></div>
				</div>
			</div>
			<div class="content_right">
				<div class="title">
					行政文书发放统计
				</div>
				<div class="right_echart">
					<div id="rightEcharts" class="full"></div>
				</div>
			</div>
		</div>
		<div class="footer">
			<div class="footer_item">
				<div class="title">
					申请类别统计
				</div>
				<div class="item_content">
					<div id="peiEcharts" class="full"></div>
				</div>
			</div>
			<div class="footer_item">
				<div class="title">
					集成资质类别申请统计
				</div>
				<div class="item_content">
					<div class="content_top" v-for="(item,index) in inteList">
						<div class="item-content-title">
							<span>{{item.name}}</span>
							<span>{{item.num}}k</span>
						</div>
						<div class="item-content-percentage">
							<div class="color-bg" :style="{width:(item.num / inteList[0].num).toFixed(2) * 100 + '%'}">
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer_item">
				<div class="title">
					印制资质类别申请统计
				</div>
				<div class="item_content">
					<div class="content_top" v-for="(item,index) in inteList">
						<div class="item-content-title">
							<span>{{item.name}}</span>
							<span>{{item.num}}k</span>
						</div>
						<div class="item-content-percentage">
							<div class="color-bg" :style="{width:(item.num / inteList[0].num).toFixed(2) * 100 + '%'}">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	export default {
		data() {
			return {
				isActive: 0,
				inteList:[
					{
						name:'总体集成',
						num:'1000'
					},
					{
						name:'总体集成',
						num:'900'
					},
					{
						name:'总体集成',
						num:'800'
					},
					{
						name:'总体集成',
						num:'700'
					},
					{
						name:'总体集成',
						num:'600'
					},
					{
						name:'总体集成',
						num:'500'
					},
					{
						name:'总体集成',
						num:'400'
					},
					{
						name:'总体集成',
						num:'300'
					},
				]
			}
		},
		mounted() {
			this.getEcharts()
			this.getRightEcharts()
			this.getPeiEcharts()
		},
		methods: {
			checkItem(val) {
				this.isActive = val
			},
			getEcharts() {
				let chartDom = document.getElementById('leftEcharts')
				let myChart = echarts.init(chartDom)
				let option = {
					color: ['#627EEA'],

					tooltip: {
						trigger: 'axis',
					},
					grid: {
						left: '0',
						right: '25',
						top: '20',
						bottom: '0',
						containLabel: true,
					},

					legend: {
						show: false,
					},
					xAxis: {
						type: 'category',
						data: ['年度自检报告', '年度自检报告', '年度自检报告', '年度自检报告', '年度自检报告', '年度自检报告', '年度自检报告'],
						boundaryGap: false,
						axisTick: {
							lineStyle: {
								color: '# d9d9d9 ',
							},
						},
						axisLine: {
							lineStyle: {
								color: '#d9d9d9',
							},
						},
						axisLabel: {
							color: '#aeaeae',
							// 坐标轴刻度标签换行处理
							formatter: function(params) {
								var newParamsName = '' // 最终拼接成的字符串
								var paramsNameNumber = params.length // 实际标签的个数
								var provideNumber = 2 // 每行能显示的字的个数
								var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
								/**
								 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
								 */
								// 条件等同于rowNumber>1
								if (paramsNameNumber > provideNumber) {
									/** 循环每一行,p表示行 */
									for (var p = 0; p < rowNumber; p++) {
										var tempStr = '' // 表示每一次截取的字符串
										var start = p * provideNumber // 开始截取的位置
										var end = start + provideNumber // 结束截取的位置
										// 此处特殊处理最后一行的索引值
										if (p === rowNumber - 1) {
											// 最后一次不换行
											tempStr = params.substring(start, paramsNameNumber)
										} else {
											// 每一次拼接字符串并换行
											tempStr = params.substring(start, end) + '\n'
										}
										newParamsName += tempStr // 最终拼成的字符串
									}
								} else {
									// 将旧标签的值赋给新标签
									newParamsName = params
								}
								return newParamsName
							}

						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							color: '#999',
							textStyle: {
								fontSize: 12,
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#F3F4F4',
								width: 2,
								type: 'dashed',
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: false,
						},
					},
					series: [{
						name: '印制资质',
						type: 'line',
						smooth: true,
						showSymbol: false,
						lineStyle: {
							width: 4
						},
						areaStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgba(98,126,234,0.8)'
									},
									{
										offset: 1,
										color: 'rgba(98,126,234,0.2)'
									}
								], false),
							}
						},
						data: [13, 1, 4, 44, 45, 322, 76],
					}, ],
				};
				option && myChart.setOption(option)
				window.addEventListener('resize', () => {
					myChart.resize()
				})
			},
			getRightEcharts() {
				let chartDom = document.getElementById('rightEcharts')
				let myChart = echarts.init(chartDom)
				let option = {
					color: ['#71B945'],

					tooltip: {
						trigger: 'axis',
					},
					grid: {
						left: '0',
						right: '25',
						top: '20',
						bottom: '0',
						containLabel: true,
					},

					legend: {
						show: false,
					},
					xAxis: {
						type: 'category',
						data: ['年度自检报告', '年度自检报告', '年度自检报告', '年度自检报告', '年度自检报告', '年度自检报告', '年度自检报告'],
						boundaryGap: false,
						axisTick: {
							lineStyle: {
								color: '# d9d9d9 ',
							},
						},
						axisLine: {
							lineStyle: {
								color: '#d9d9d9',
							},
						},
						axisLabel: {
							color: '#aeaeae',
							// 坐标轴刻度标签换行处理
							formatter: function(params) {
								var newParamsName = '' // 最终拼接成的字符串
								var paramsNameNumber = params.length // 实际标签的个数
								var provideNumber = 2 // 每行能显示的字的个数
								var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
								/**
								 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
								 */
								// 条件等同于rowNumber>1
								if (paramsNameNumber > provideNumber) {
									/** 循环每一行,p表示行 */
									for (var p = 0; p < rowNumber; p++) {
										var tempStr = '' // 表示每一次截取的字符串
										var start = p * provideNumber // 开始截取的位置
										var end = start + provideNumber // 结束截取的位置
										// 此处特殊处理最后一行的索引值
										if (p === rowNumber - 1) {
											// 最后一次不换行
											tempStr = params.substring(start, paramsNameNumber)
										} else {
											// 每一次拼接字符串并换行
											tempStr = params.substring(start, end) + '\n'
										}
										newParamsName += tempStr // 最终拼成的字符串
									}
								} else {
									// 将旧标签的值赋给新标签
									newParamsName = params
								}
								return newParamsName
							}

						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							color: '#999',
							textStyle: {
								fontSize: 12,
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#F3F4F4',
								width: 2,
								type: 'dashed',
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: false,
						},
					},
					series: [{
						name: '印制资质',
						type: 'line',
						smooth: true,
						showSymbol: false,
						lineStyle: {
							width: 4
						},
						areaStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgba(113,185,69,0.8)'
									},
									{
										offset: 1,
										color: 'rgba(113,185,69,0.2)'
									}
								], false),
							}
						},
						data: [113, 51, 44, 144, 45, 32, 176],
					}, ],
				};
				option && myChart.setOption(option)
				window.addEventListener('resize', () => {
					myChart.resize()
				})
			},
			getPeiEcharts() {
				let chartDom = document.getElementById('peiEcharts')
				let myChart = echarts.init(chartDom)
				let data = [{
						name: '集成资质',
						value: 5
					},
					{
						name: '印制资质',
						value: 6
					},
					{
						name: '军工资质',
						value: 9
					},
				]
				let totalNum = 0
				data.map(item => totalNum += item.value)
				let option = {
					color: [
						'#0045E6',
						'#F7931A',
						'#44B4AD'
					],
					legend: {
						orient: 'vertical',
						icon: 'circle',
						bottom: 15,
						textStyle: {
							rich: {
								b: {
									padding: [0, 2, 0, 40],
									fontSize: 14,
									color: '#24262b'
								},
								c: {
									fontSize: 14,
									color: '#24262b'
								},
							}
						},
						formatter(name) { // 该函数用于设置图例显示后的百分比
							let total = 0
							let value = 0
							data.forEach((item) => {
								total += item.value
								if (item.name == name) {
									value = item.value
								}
							})
							let p = ((value / total) * 100).toFixed(1) // 求出百分比
							return ['{c|' + `${name}${'('+p+'%'+')'}` + '}{b|' + `${value}` + '}']
						},
					},
					tooltip: {
						trigger: 'item',
					},

					series: [{
						type: 'pie',
						radius: ['30%', '60%'],
						center: ['50%', '50%'],
						roseType: 'radius',
						minShowLabelAngle: 60,
						label: {
							show: true,
							position: 'center',
							color: '#24262b',
							formatter: '{a|全部}' + '\n\r' + '{b|' + totalNum + '}',
							rich: {
								a: {
									fontSize: 14,
									fontFamily: "微软雅黑",
									color: '#24262b'
								},
								b: {
									fontFamily: "微软雅黑",
									fontSize: 28,
									color: '#24262b',
									lineHeight: 40,
								},
							}
						},
						labelLine: {
							length: 1,
							length2: 10,
							smooth: true
						},
						data: data,
					}]
				};
				option && myChart.setOption(option)
				window.addEventListener('resize', () => {
					myChart.resize()
				})
			},
			}
	}
</script>

<style lang="less" scoped>
	.wrap {
		width: 100%;
		height: 100%;
		padding: 24px !important;
		box-sizing: border-box;

		.title {
			height: 26px;
			font-family: Microsoft YaHei;
			font-size: 20px;
			font-weight: normal;
			font-stretch: normal;
			line-height: 24px;
			letter-spacing: 0px;
			color: #24262b;
			display: flex;
			justify-content: space-between;
		}

		.head {
			display: flex;
			justify-content: space-evenly;
			height: 160px;
			background-color: #ffffff;
			box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
			border-radius: 16px;

			.head_item {
				width: 260px;
				height: 160px;
				padding: 50px 24px;
				display: flex;
				box-sizing: border-box;

				.item_img {
					width: 60px;
					height: 60px;

					img {
						width: 100%;
					}
				}

				.item_text {
					margin-left: 16px;
					font-size: 14px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 17px;
					letter-spacing: 0px;
					color: #545454;

					div:nth-child(1) {
						font-size: 28px;
						line-height: 36px;
						color: #24262b;
					}
				}
			}
		}

		.tabs {
			display: flex;
			margin-top: 16px;

			.tabs_item {
				margin-right: 30px;
				color: #9699a0;

			}

			.isItem {
				font-weight: bold;
				color: #0147eb !important;
			}
		}

		.content {
			display: flex;
			margin: 16px 0;

			.content_left {
				width: 50%;
				background-color: #ffffff;
				box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
				border-radius: 20px;
				margin-right: 16px;
				padding: 24px;
				box-sizing: border-box;

				.left_echart {
					width: 100%;
					height: 400px;
				}
			}

			.content_right {
				width: 50%;
				background-color: #ffffff;
				box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
				border-radius: 20px;
				padding: 24px;
				box-sizing: border-box;

				.right_echart {
					width: 100%;
					height: 400px;
				}
			}
		}

		.footer {
			display: flex;

			.footer_item {
				width: 33%;
				background-color: #ffffff;
				box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
				border-radius: 20px;
				padding: 24px;
				box-sizing: border-box;

				.item_content {
					width: 100%;
					height: 450px;
					.content_top{
						height: 38px;
						margin: 18px 0;
						.item-content-title{
							font-size: 14px;
							color: #545454;
							display: flex;
							justify-content: space-between;
						}
						.item-content-percentage {
							position: relative;
							height: 12px;
							background: #f5f6fa;
							border-radius: 8px;
							margin-top: 7px;
						
							.color-bg {
								position: absolute;
								border-radius: 8px;
								top: 0;
								line-height: 0;
								height: 12px;
								background-color: #0147EB;
								width: 80%;
							}
						}
					}
					
				}
			}

			.footer_item:nth-child(2) {
				margin: 0 16px;
			}
		}
	}
</style>
